import { UseFormReturn } from "react-hook-form";
import { Button, Card, Table } from "react-bootstrap";
import { IKontrollResultSEKRow } from "../../../types/BFL/Funktionskontroll";
import { bfKeyForHelp, numFrmt0Dec } from "../../../modules/common";
import { BFLType } from "../../../types/DBTables";

interface IProps {
  bfName: string;
  formHook: UseFormReturn;
  funktionsKontrollerSEK: IKontrollResultSEKRow[];
}

const DriftOptimeringarSEK = ({ bfName, funktionsKontrollerSEK, formHook }: IProps) => {
  if (!funktionsKontrollerSEK || !funktionsKontrollerSEK.length) return <></>;
  const showSEKs = funktionsKontrollerSEK.find((r) => r.sek) ? true : false;
  //+ showSEKs ? " SEK" : ""

  const dbg = formHook.watch();
  return (
    <>
      <Card className="mb-3">
        <Card.Header>{"Funktionskontroller"}</Card.Header>
        <Table bordered hover>
          <thead>
            <tr>
              {showSEKs ? <th style={{ width: 150 }}>SEK/år</th> : <></>}

              <th>Meddelande funktionskontroll </th>
              <th style={{ width: 50 }}>Visa</th>
              <th style={{ width: 50 }}>Åtgärdad</th>
            </tr>
          </thead>
          <tbody>
            {funktionsKontrollerSEK.map((fk, index) => (
              <tr key={fk.index}>
                {showSEKs ? (
                  <td>
                    {fk.sek ? numFrmt0Dec.format(fk.sek) : ""}
                    <input type="hidden" {...formHook.register("funktionsKontrollerSEK." + index + ".kWhs", { value: fk.sek })} />
                  </td>
                ) : (
                  <></>
                )}

                <td>
                  {fk.message}
                  <input type="hidden" {...formHook.register("funktionsKontrollerSEK." + index + ".message", { value: fk.message })} />
                </td>
                <td>
                  <Button style={{ fontSize: "0.8em", minWidth: 70, padding: "5px 0px" }} onClick={() => PubSub.publish("ShowHelp", bfKeyForHelp[bfName as BFLType] + "_FKText" + fk.index)}>
                    Mer info
                  </Button>
                </td>
                <td style={{ textAlign: "center" }}>
                  {fk.VisaÅtgärdad ? (
                    <input type="checkbox" {...formHook.register("funktionsKontrollerSEK." + index + ".Åtgärdad")} className="form-check-input" />
                  ) : (
                    <input type="hidden" {...formHook.register("funktionsKontrollerSEK." + index + ".Åtgärdad", { value: false })} />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  );
};

export default DriftOptimeringarSEK;
